import React,{useEffect,useState} from "react";
import {Link,useLocation} from "react-router-dom";
import ImageWithBasePath from "../../img";
import {all_routes} from "../../../feature-module/router/all_routes";
import {header} from "./headerData";
import {setDataTheme} from "../../redux/themeSettingSlice";
import {useDispatch,useSelector} from "react-redux";
// -- biz9 --
import {Type,Url,Field,Title} from "../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../project";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Log,Str} from "biz9-utility";
const Header = () => {
  const routes = all_routes;
  const [user,setUser] = useState(User.get());
  const [scrolled, setScrolled] = useState(false);
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const [subsidebar2, setSubsidebar2] = useState("");
  const [basePath, setBasePath] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const handleDataThemeChange = (theme: string) => {
    dispatch(setDataTheme(theme));
  };
  const onHandleMobileMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.add("menu-opened");
  };
  const onhandleCloseMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };
  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };
  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const toggleSubsidebar2 = (subitem: any) => {
    if (subitem === subsidebar2) {
      setSubsidebar2("");
    } else {
      setSubsidebar2(subitem);
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    // Add event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const path = location.pathname;
    const pathArray = path.split("/").filter(Boolean); // Removes empty strings from the split result
    setBasePath(pathArray[0]);
  }, [location.pathname]);
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", dataTheme);
  }, [dataTheme]);
  async function btn_dashboard() {
      Storage.post_dashboard_type_user();
    };

  return (
    <header className={`header ${scrolled ? "fixed" : ""}`}>
      <div className="container">
        <nav className="navbar navbar-expand-lg header-nav p-0">
          <div className="navbar-header">
            <Link id="mobile_btn" to="#" onClick={() => onHandleMobileMenu()}>
              <span className="bar-icon">
                <span />
                <span />
                <span />
              </span>
            </Link>
            <Link to={routes.home} className="navbar-brand logo">
              <ImageWithBasePath
                src="/assets/img/logo.png"
                className="img-fluid"
                alt="Logo"
              />
            </Link>
            <Link to={routes.home} className="dark-logo">
              <ImageWithBasePath
                src="/assets/img/dark-logo.png"
                alt="Logo"
                className="img-fluid"
              />
            </Link>
            <Link to={routes.home} className="navbar-brand logo-small">
              <ImageWithBasePath
                src="/assets/img/logo.png"
                className="img-fluid"
                alt="Logo"
              />
            </Link>
          </div>
          <div className="main-menu-wrapper">
            <div className="menu-header">
              <Link to={routes.home} className="menu-logo">
                <ImageWithBasePath
                  src="/assets/img/logo.png"
                  className="img-fluid"
                  alt="Logo"
                />
              </Link>
              <Link to={routes.home} className="menu-logo dark-logo">
                <ImageWithBasePath
                  src="/assets/img/dark-logo.png"
                  alt="Logo"
                  className="img-fluid"
                />
              </Link>
              <Link
                id="menu_close"
                className="menu-close"
                to="#"
                onClick={() => onhandleCloseMenu()}
              >
                {" "}
                <i className="fas fa-times" />
              </Link>
            </div>
            <ul className="main-nav  navbar-nav">
                <li className={`has-submenu ${location.pathname == '/index' ? "active" : "" }`}>
                <Link to={all_routes.home}>{Title.LABEL_MENU_HOME}</Link>
                </li>
                <li className={`has-submenu ${location.pathname.includes('/app')  ? "active" : "" }`}>
                <Link to={all_routes.product_app}>{Title.LABEL_MENU_APPZ}</Link>
                </li>
                <li className={`has-submenu ${location.pathname.includes('/faq')  ? "active" : "" }`}>
                <Link to={all_routes.faq}>{Title.LABEL_MENU_FAQ}</Link>
                </li>
                <li className={`has-submenu ${location.pathname.includes('/portfolio') ? "active" : "" }`}>
                <Link to={all_routes.gallery}>{Title.LABEL_MENU_PORTOFOLIO}</Link>
                </li>
                 <li className={`has-submenu ${location.pathname.includes('/reviews') ? "active" : "" }`}>
                <Link to={all_routes.review}>{Title.LABEL_MENU_REVIEW}</Link>
                </li>
                <li className={`has-submenu ${location.pathname.includes('/blog') ? "active" : "" }`}>
                <Link to={all_routes.blog_post}>{Title.LABEL_MENU_BLOG}</Link>
                </li>
                <li className={`has-submenu  ${location.pathname == '/about' ||location.pathname == '/team' ? "active" : "" }`}>
                    <Link to={all_routes.about}>{'About'}<i className="fas fa-chevron-down"> </i></Link>
                    <ul className="submenu  d-block">
								<li className={`${location.pathname == '/about' ? "active" : "" }`}> <Link to={all_routes.about}>{Title.LABEL_MENU_ABOUT}</Link></li>
								 <li className={`${location.pathname == '/team' ? "active" : "" }`}>  <Link to={all_routes.team}>{Title.LABEL_MENU_TEAM}</Link></li>
								</ul>
                </li>
                <li className={`has-submenu ${location.pathname == '/contact' ? "active" : "" }`}>
                <Link to={all_routes.contact}>Contact</Link>
                </li>
            </ul>
          </div>
          <div className="d-flex align-items-center">
            <div className="nav-item dropdown flag-nav nav-item-box nav-item-box-home me-2">
              <Link
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                to="#"
                role="button"
              >
                <ImageWithBasePath
                  src="/assets/img/flags/us.svg"
                  alt="Language"
                  className="img-fluid"
                />
              </Link>
              <ul className="dropdown-menu p-2">
                <li className="mb-1">
                  <Link
                    to="#"
                    className="dropdown-item rounded-2 d-flex align-items-center"
                  >
                    <ImageWithBasePath
                      src="/assets/img/flags/us.svg"
                      alt=""
                      height={16}
                      className="img-fluid me-2"
                    />
                    English
                  </Link>
                </li>
                <li className="mb-1">
                  <Link
                    to="#"
                    className="dropdown-item rounded-2 d-flex align-items-center"
                  >
                    <ImageWithBasePath
                      src="/assets/img/flags/de.svg"
                      alt=""
                      height={16}
                      className="img-fluid me-2"
                    />
                    German
                  </Link>
                </li>
                <li className="mb-1">
                  <Link
                    to="#"
                    className="dropdown-item rounded-2 d-flex align-items-center"
                  >
                    <ImageWithBasePath
                      src="/assets/img/flags/fr.svg"
                      alt="Image"
                      height={16}
                      className="img-fluid me-2"
                    />
                    French
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-2 d-flex align-items-center"
                  >
                    <ImageWithBasePath
                      src="/assets/img/flags/ae.svg"
                      alt="Image"
                      height={16}
                      className="img-fluid me-2"
                    />
                    Arabic
                  </Link>
                </li>
              </ul>
            </div>
            <div className="nav-item dropdown flag-nav nav-item-box nav-item-box-home me-3">
              <Link
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                to="#"
                role="button"
              >
                <i
                  className={`ti  ${
                    dataTheme === "light" ? "ti-sun-high" : "ti-moon"
                  }`}
                />
              </Link>
              <ul className="dropdown-menu p-2">
                <li className="mb-1">
                  <Link
                    to="#"
                    className={`dropdown-item theme-toggle rounded-2 ${
                      dataTheme === "light" && "active"
                    }`}
                    id="light-mode-toggle"
                    onClick={() => handleDataThemeChange("light")}
                  >
                    <i className="ti ti-sun-high me-2" />
                    Light Mode
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item theme-toggle rounded-2 ${
                      dataTheme === "dark" && "active"
                    }`}
                    id="dark-mode-toggle"
                    onClick={() => handleDataThemeChange("dark")}
                  >
                    <i className="ti ti-moon me-2" />
                    Dark Mode
                  </Link>
                </li>
              </ul>
            </div>
         <ul className="nav header-navbar-rht">
              <li className="nav-item">
                { user.is_guest ? (
                <Link className="btn btn-light d-inline-flex align-items-center" to={all_routes.login} >
                <i className="ti ti-lock me-1" />
                  Sign In
                </Link>
                ) : (
                <Link onClick={() => btn_dashboard()} className="btn btn-light d-inline-flex align-items-center" to={all_routes.dashboard_user_home} >
                <i className="ti ti-lock me-1" />
                  Dashboard
                </Link>
                )
                }
              </li>
            { user.is_guest && (
              <li className="nav-item">
                <Link className="btn btn-primary d-inline-flex align-items-center" to={all_routes.register}>
                  <i className="ti ti-user me-1" />
                  Sign Up
                </Link>
              </li>
            )}
            </ul>
        </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
